import { render, staticRenderFns } from "./ListMisc.vue?vue&type=template&id=0b4e19c2&lang=pug"
import script from "./ListMisc.vue?vue&type=script&lang=js"
export * from "./ListMisc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports